import { get2 } from "@/shared/axios";
import { PaymentLedger } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";

const usePaymentLedgerQuery = (id: number, isSession: boolean) => {
  const url = isSession
    ? `/internal/secure/pos/v1/orders/session-orders-payment-ledger/${id}`
    : `/internal/secure/pos/v1/orders/single-order-payment-ledger/${id}`;

  const query = useQuery<PaymentLedger[]>({
    queryKey: ["paymentLedger", id],
    enabled: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    queryFn: () => get2(url),
  });

  return query;
};

export default usePaymentLedgerQuery;
